import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {DateTime} from "../../components/ListComponent/DateTime";
import {ArrowDownSquareFill} from "react-bootstrap-icons";
import {Util} from "../../components/Util";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";

export class WarehouseValue extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return `/report/warehouse-value`;
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const params: {} | any = this.getFormData(), dictionary = this.dictionary;

        const searchBarClassList = window.location.hash ? 'search-bar' : 'search-bar hidden';

        return (
            <>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['search']}
                        <span onClick={this.toggleSearchBar} style={{
                            cursor: 'pointer',
                            fontWeight: 'normal',
                            paddingLeft: '20px',
                            fontSize: '13px'
                        }}><ArrowDownSquareFill/> {this.dictionary.get['detailed-search']}</span>
                    </h5>

                    <form className="x-form" method="GET" onSubmit={this.handleSubmit}>
                        <div className={searchBarClassList}>
                            <div className="row">
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'created_from', defaultValue: params?.created_from}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'created_to', defaultValue: params?.created_to}}/>
                                </div>
                                {/*<div className="col-md-6 col-lg-4 col-xl-3">*/}
                                {/*    <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>*/}
                                {/*</div>*/}
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? '`is`.id:d'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption details">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/report/warehouse-value/export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6 style={{width: '100%'}}>
                                    {this.dictionary.get['warehouse-value']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="`is`.id">
                                    #ID<i className="bi bi-sort-down"></i>
                                </th>
                                <th className="sortable" data-sortkey="`is`.name">{this.dictionary.get['name']}</th>
                                <th className="sortable" align={"right"}
                                    data-sortkey="`is`.product_count">{this.dictionary.get['product_count']}</th>
                                <th className="sortable" align={"right"}
                                    data-sortkey="`is`.unit_cost">{this.dictionary.get['unit_cost_all']}</th>
                                <th className="sortable" align={"right"}
                                    data-sortkey="`is`.pc_wo_unit_cost">{this.dictionary.get['pc_wo_unit_cost']}</th>

                                <th className="sortable" data-sortkey="os.created_at">
                                    {this.dictionary.get['created_at']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                return (
                                    <tr key={elem.id} data-id={elem.id}>
                                        <td>{Util.link(elem.id, '/product/snapshot-history#snapshot_id=' + elem.id)}</td>
                                        <td>{elem.name}</td>

                                        <td align={"right"}>{elem.product_count ?
                                            <FormattedNumber value={elem.product_count}
                                                             suffix={dictionary.get['pc']}/> : '-'}</td>

                                        <td align={"right"}>{elem.unit_cost ?
                                            <FormattedNumber value={elem.unit_cost} suffix={"EUR"}/> : '-'}</td>

                                        <td align={"right"}>
                                            {elem.pc_wo_unit_cost ?
                                                <FormattedNumber value={elem.pc_wo_unit_cost}
                                                                 suffix={dictionary.get['pc']}/> : '-'}</td>

                                        <td><DateTime value={elem.created_at} inline={true}/></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={3}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
